<template>
    <div class="my-page__tab">
        <ul class="my-page__list inner">
            <li :class="{'my-page__item': true, 'active': myPageMenuActive(menu)}" v-for="menu in menuArr">
                <router-link :to="menu.menuUrl">{{menu.menuName}}</router-link>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    data() {
        return {
            menuArr: []
        }
    },
    methods: {
        setMenu(){
            const list = this.menuList.sort((a, b) => {
                return a.depth - b.depth
            })
            let menuNo = ''
            for(let i of this.menuList){
                if(i.menuName == '내 진료 정보') menuNo = i.menuNo
                if(i.useYn == 'Y' && i.parentMenuNo == menuNo ) this.menuArr.push(i)
            }
        },
        myPageMenuActive(menu){
            let result = false

            if(this.$route.path == menu.menuUrl){
                result = true

                return result
            }

            for(let i of this.menuList){
                if(i.menuUrl == this.$route.path && i.parentMenuNo == menu.menuNo){
                    result = true
                    break
                }
            }

            return result
        }
    },
    mounted() {
        this.setMenu()
    },
}
</script>